import type { resourceBundle } from '../types/hippoTypes';
import { selector } from 'recoil';
import { topConfigContextAtom } from '../atoms/topConfigContextAtom';
import { get as axiosGet } from '../../services/axios.service';

export const getHippoResourceBundleSelector = selector<resourceBundle>({
    key: 'hippoResourceBundleSelector',
    get: async ({ get }) => {
        const configAtom = get(topConfigContextAtom);

        if (!configAtom) {
            throw new Error('Invalid top config context');
        }

        const resourceId = 'dk.guidewire-top-online-sales';
        return await axiosGet<resourceBundle>(
            `${configAtom.endpointConfig.resourceBundle}/${resourceId}`
        );
    }
});
